import type { User } from '@/types/common';
import { MobilePermissionPageKey, PermissionPageKey } from '@/types/permission';
import appUtil from '@/utils/app';
import type { RouteLocationNormalized, Router } from 'vue-router';
import { routes } from './config/route';

const mobileClient = {
  /**
   * @description 路由添加
   */
  addMobileRouteToRouter(router: Router) {
    router.addRoute(routes);
  },

  /**
   * @description 额外的路由权限处理
   */
  permissionGuard(
    to: RouteLocationNormalized,
    opt: {
      user?: User;
    },
  ): any | boolean {
    if (!appUtil.isMobile()) {
      // 非移动端设备，返回 false 不处理
      return false;
    }
    // 移动端设备处理逻辑
    if (!opt.user) {
      if (
        to.path === '/mobile/login' ||
        to.path === '/mobile/login-account' ||
        to.path === '/mobile/login-feishu'
      ) {
        return true;
      }
      return {
        path: '/mobile/login',
        query: { ...to.query, redirect: to.path },
      };
    }

    // 已登录
    if (
      to.path === '/mobile/login' ||
      to.path === '/mobile/login-account' ||
      to.path === '/mobile/login-feishu'
    ) {
      return { path: '/mobile/home' };
    }

    // 问题路由单跳转处理
    if (to.name === PermissionPageKey.IssueDetail) {
      return { name: MobilePermissionPageKey.IssueFormRead, params: to.params };
    }

    // 制程问题库跳转
    if (to.path === '/production/produce-issue') {
      return {
        path: '/mobile/produce-issue',
        query: to.query,
      };
    }

    // 非移动端路由跳转
    if (!to.path.match(/^\/mobile\/.*/)) {
      return { path: '/mobile/home' };
    }

    return true;
  },
};

export { mobileClient };
